import React from "react";
import { useTranslation } from "react-i18next";

import { useCategorySuggestions } from "./hooks/useCategorySuggestions";
import { AutocompleteSuggestions } from "../../../../../HookForm/AutocompleteSuggestions";

import "./styles.scss";

export interface ICategorySuggestionProps {
  locationId: number;
  onSelectSuggestion: (name: string) => void;
}

export const CategorySuggestions = ({
  locationId,
  onSelectSuggestion,
}: ICategorySuggestionProps) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityDetailsPage.modalEditProfile.categoryForm.suggestions.${key}`);

  const { suggestions, handleSelectSuggestion, refetch } =
    useCategorySuggestions(locationId, onSelectSuggestion);

  return (
    <div className="category-suggestions">
      <AutocompleteSuggestions
        suggestions={suggestions}
        onSelectSuggestion={handleSelectSuggestion}
      />
      <button
        className="btn btn-border fetch-suggestions-button"
        type="button"
        onClick={() => refetch()}
      >
        {suggestions.length > 0
          ? t("refetch_suggestions")
          : t("get_suggestions_from_ai")}
      </button>
    </div>
  );
};
